import { debounce } from "../helpers/debounce";
import { formatPrice } from "../helpers/formatPrice";

export const calculator = () => {
    if (!servObj.isRedactorMode) return;

    const total_price_node = document.getElementById("total_price");
    const calc = servObj.calc;

    let total_price = 0;
    let hasZeroPrice = false;

    const isEsdPrice = !!calc.isEsdPrice;

    Object.values(calc).forEach((item) => {
        if (item && typeof item === "object" && item.active) {
            let currentPrice = 0;

            if (isEsdPrice) {
                if (item.position === "table") {
                    currentPrice = item.price_esd ?? 0;
                } else {
                    currentPrice = item.price_esd && item.price_esd !== 0 ? item.price_esd : item.price;
                }
            } else {
                currentPrice = item.price;
            }

            if (currentPrice === 0) {
                hasZeroPrice = true;
            }

            total_price += currentPrice * item.piece;
        }
    });

    const finalValue = hasZeroPrice ? "По запросу" : total_price;

    setTotalPrice(total_price_node, finalValue);

    servObj.calc.total = hasZeroPrice ? 0 : total_price;
    servObj.redactorModeObject.userData.totalPrice = finalValue;
};

let currentAnimationFrame = null;

export function animatePrice(from, to, element) {
    // останавливаем предыдущую анимацию
    if (currentAnimationFrame) {
        cancelAnimationFrame(currentAnimationFrame);
        currentAnimationFrame = null;
    }

    const duration = 600;
    const frameRate = 80;
    const totalFrames = Math.round(duration / (1000 / frameRate));
    let frame = 0;

    function animate() {
        frame++;
        const progress = frame / totalFrames;
        const current = Math.round(from + (to - from) * progress);

        element.textContent = isNaN(current) ? formatPrice(0) : formatPrice(current);

        if (frame < totalFrames) {
            currentAnimationFrame = requestAnimationFrame(animate);
        } else {
            element.textContent = formatPrice(to);
            currentAnimationFrame = null;
        }
    }

    currentAnimationFrame = requestAnimationFrame(animate);
}

function setTotalPrice(element, value) {
    const currentText = element.textContent.trim();

    // если "По запросу"
    if (value === "По запросу") {
        if (currentAnimationFrame) {
            cancelAnimationFrame(currentAnimationFrame);
            currentAnimationFrame = null;
        }

        element.textContent = "По запросу";
        return;
    }

    // если было "По запросу" → просто ставим число без анимации
    if (currentText === "По запросу") {
        if (currentAnimationFrame) {
            cancelAnimationFrame(currentAnimationFrame);
            currentAnimationFrame = null;
        }

        element.textContent = formatPrice(value);
        return;
    }

    // обычная анимация
    const fromValue = Number(currentText.replace(/\s|₽/g, "")) || 0;
    animatePrice(fromValue, value, element);
}

export const debouncedCalculator = debounce(calculator, 100);
export function setActiveCalcValue(id, isActive, piece = 0, placement = null, maxPieces = null) {
    const item = servObj.calc[id];
    if (!item) return console.warn(`id ${id} не найден`);
    // console.log(`id: ${id}, isActive: ${isActive}, piece: ${piece}, placement: ${placement}, maxPieces: ${maxPieces}`);

    // Отключаем элементы из той же группы
    Object.entries(servObj.calcObserver).forEach(([key, el]) => {
        if (el.group && el.group === item.group && isActive) {
            const boolean = el.piece > 0 && el.type !== item.type;
            if (placement) {
                if (boolean) {
                    el[placement] = el[placement] > 1 ? el[placement] - 1 : 0;
                    el.piece = el.front + el.back;
                    if (el.piece < 1) el.active = false;
                }
            } else {
                if (boolean) {
                    el.piece = el.piece > 1 ? el.piece - 1 : 0;
                    if (el.piece < 1) el.active = false;
                }
            }
        }
    });

    // Устанавливаем активность и количество
    const observerItem = servObj.calcObserver[id];

    if (placement === "front" || placement === "back") {
        if (!observerItem.front) observerItem.front = 0;
        if (!observerItem.back) observerItem.back = 0;
        observerItem[placement] = maxPieces
            ? Math.min(maxPieces, Math.max(piece + (isActive ? +1 : -1), 0))
            : Math.max(piece + (isActive ? +1 : -1), 0);
    }

    observerItem.piece = placement
        ? +observerItem.front + +observerItem.back
        : Math.min(
              maxPieces ?? Infinity,
              Math.max(!observerItem.isMultyPieces ? piece + (isActive ? +1 : -1) : piece, 0),
          );
    observerItem.active = observerItem.piece < 1 ? false : true;

    if (observerItem.isMultyPieces && observerItem.piece === 0) observerItem.active = false;

    setCalcValueIbUserData(servObj.redactorModeObject);
    debouncedCalculator();
}
export function updateCalcForPlacement(calcName, isChecked, placement = null, maxPieces = null) {
    const preventPiece =
        (placement ? servObj.calcObserver[calcName][placement] : servObj.calcObserver[calcName].piece) || 0;
    setActiveCalcValue(calcName, isChecked, preventPiece, placement, maxPieces);
}
export function setMultyPiecesItemCalc(calcName, isActive) {
    const preventPiece = servObj.calc[calcName].piece;
    const piece = preventPiece + (isActive ? +1 : -1);
    setActiveCalcValue(calcName, isActive, piece);
}
export function getCalcPriceById(id) {
    const item = servObj.calc[id];
    if (!item || typeof item !== "object") {
        console.warn(`Элемент с id ${id} не найден`);
        return 0;
    }

    if (!item.active) return 0;

    const isEsdPrice = !!servObj.calc.isEsdPrice;
    const isMultyPieces = item.isMultyPieces || false;

    if (isEsdPrice) {
        const priceValue = item.price_esd && item.price_esd !== 0 ? item.price_esd : item.price;
        return isMultyPieces ? priceValue * item.piece : priceValue;
    } else {
        return isMultyPieces ? item.price * item.piece : item.price;
    }
}
export function resetCalculator() {
    // Сброс активных элементов и количества
    Object.values(servObj.calcObserver).forEach((item) => {
        if (typeof item === "object") {
            item.active = false;
            item.piece = 0;
        }
    });

    // Сброс итоговых значений
    servObj.calc.total = 0;
    if (servObj.redactorModeObject?.userData) {
        servObj.redactorModeObject.userData.totalPrice = 0;
    }

    debouncedCalculator();
}
export function resetCalculatorWithResetParams() {
    // Сброс активных элементов и количества
    Object.values(servObj.calcObserver).forEach((item) => {
        if (typeof item === "object") {
            item.active = false;
            item.piece = 0;
        }
    });

    if (servObj.isRedactorMode) {
        const glbName = servObj.redactorModeObject.userData.loadData.glbName;
        let name = glbName.replace(".glb", "");
        if (servObj.redactorModeObject.userData.loadData.folderName === "stulya") {
            name = `stul__${servObj.tempName}`;
        }
        if (servObj.redactorModeObject.userData.loadData.folderName === "stellazhi") {
            name = `stellazh__${servObj.tempName}`;
        }

        // превращаем объект в массив пар [ключ, значение], фильтруем, а потом обратно в объект
        const calcActives = Object.fromEntries(
            Object.entries(servObj.redactorModeObject.userData.calcActives).filter(([key]) => key.includes(name)),
        );

        servObj.redactorModeObject.userData.calcActives = calcActives;
    }

    // Сброс итоговых значений
    servObj.calc.total = 0;
    if (servObj.redactorModeObject?.userData) {
        servObj.redactorModeObject.userData.totalPrice = 0;
    }

    debouncedCalculator();
}
export function updateTotalBuildingPrice() {
    const total_price_node = document.getElementById("total_price");
    if (!total_price_node) return;

    let total = 0;
    let hasRequestPrice = false;

    for (const obj of servObj.building._objects) {
        const price = obj?.userData?.totalPrice;

        if (price === "По запросу") {
            hasRequestPrice = true;
            break;
        }

        if (typeof price === "number" && !isNaN(price)) {
            total += price;
        }
    }

    const finalValue = hasRequestPrice ? "По запросу" : total;

    setTotalPrice(total_price_node, finalValue);
}
export function restoreCalcActives() {
    const savedActives = servObj.redactorModeObject.userData.calcActives;
    if (!savedActives || typeof savedActives !== "object") return;
    resetCalculator();

    for (const [id, { piece }] of Object.entries(savedActives)) {
        if (servObj.calc[id]) {
            servObj.calc[id].active = true;
            servObj.calc[id].piece = piece;
            // servObj.calcObserver[id].id = id;
        }
    }

    debouncedCalculator();
}
export function setCalcValueIbUserData(obj) {
    // Обновляем calcActives в виде объекта
    const userData = obj.userData;
    if (userData) {
        userData.calcActives = {};

        const activeItems = Object.entries(servObj.calc)
            .filter(([, item]) => item.active)
            .map(([id, item]) => ({
                id,
                piece: item.piece || 0,
            }));

        activeItems.forEach(({ id, piece }) => {
            userData.calcActives[id] = { piece, id };
        });
    }
}
